module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_11.bb4b6457.pdf";